import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel/textLabel';
import Text from '../text/text';
import classNames from 'classnames';
import { CollapseArrow as CollapseArrowCE } from '@wix/wix-ui-icons-common/classic-editor/system';
import { CollapseArrow as CollapseArrowRE } from '@wix/wix-ui-icons-common/responsive-editor/system';
import { WixBaseUiEnvironmentContext } from '../../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
var collapseLabel = /*#__PURE__*/function (_React$Component) {
  function collapseLabel(props) {
    var _this;
    _classCallCheck(this, collapseLabel);
    _this = _callSuper(this, collapseLabel, [props]);
    _this.state = {
      isOpen: false,
      childHasHover: false
    };
    _this.onToggle = function () {
      if (!_this.props.disabled) {
        if (_this.props.customToggle) {
          _this.props.customToggle();
          _this.callOnToggleIfNeeded(!_this.props.isOpen);
        } else {
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              isOpen: !prevState.isOpen
            });
          }, function () {
            return _this.callOnToggleIfNeeded(_this.state.isOpen);
          });
        }
      }
    };
    _this.callOnToggleIfNeeded = function (isOpen) {
      if (_this.props.onToggle) {
        _this.props.onToggle(isOpen);
      }
    };
    _this.isChildHover = function () {
      return _this.state.childHasHover;
    };
    _this.handleOnMouseEnter = function () {
      return !_this.state.childHasHover && _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        childHasHover: true
      }));
    };
    _this.handleOnMouseLeave = function () {
      return _this.state.childHasHover && _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        childHasHover: false
      }));
    };
    _this.getIconState = function () {
      return _this.isOpen() ? 'open' : 'closed';
    };
    _this.isOpen = function () {
      return _this.props.customToggle ? _this.props.isOpen : _this.state.isOpen;
    };
    return _this;
  }
  _inherits(collapseLabel, _React$Component);
  return _createClass(collapseLabel, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var suffixArray = this.props.suffix && (Array.isArray(this.props.suffix) ? this.props.suffix : [this.props.suffix]);
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapse-label-root",
        "data-hook": this.props.dataHook,
        className: classNames(this.props.getClassName('control-collapse-label'), this.props.disabled ? 'disabled' : '', this.isChildHover() ? 'child-has-hover' : '', this.props.divider === 'enabled' ? 'with-bottom-divider' : '')
      }, /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapse-label-switch",
        className: classNames('collapse-label-switch', "skin-".concat(this.props.skin), this.props.disabled ? 'disabled' : ''),
        onClick: this.onToggle,
        "aria-checked": this.isOpen()
      }, /*#__PURE__*/React.createElement("div", {
        className: "left-wrapper"
      }, this.props.prefix && /*#__PURE__*/React.createElement("div", {
        className: "prefix-wrapper",
        "data-aid": "collapse-label-prefix"
      }, this.props.prefix), /*#__PURE__*/React.createElement(WixBaseUiEnvironmentContext.Consumer, null, function (value) {
        return (value === null || value === void 0 ? void 0 : value.theme) === 'responsive' ? /*#__PURE__*/React.createElement(TextLabel, {
          className: "collapse-text-label",
          automationId: "collapse-text-label",
          value: _this2.props.translateIfNeeded(_this2.props.label),
          type: "T15",
          disabled: _this2.props.disabled,
          shouldTranslate: _this2.props.shouldTranslate
        }) : /*#__PURE__*/React.createElement(Text, {
          dataHook: "collapse-text-label",
          size: "small",
          weight: "bold",
          skin: "standard",
          disabled: _this2.props.disabled,
          translateIfNeeded: _this2.props.translateIfNeeded,
          shouldTranslate: _this2.props.shouldTranslate
        }, _this2.props.label);
      })), /*#__PURE__*/React.createElement("div", {
        className: "right-wrapper"
      }, this.props.suffix && /*#__PURE__*/React.createElement("div", {
        className: classNames('suffix-wrapper', {
          'show-suffix': this.props.alwaysShowSuffix
        }),
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, suffixArray.map(function (suffix, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "suffix-item"
        }, suffix);
      })), /*#__PURE__*/React.createElement("div", {
        "data-aid": "switch-open",
        className: 'switch-open ' + this.getIconState()
      }, /*#__PURE__*/React.createElement(WixBaseUiEnvironmentContext.Consumer, null, function (value) {
        return (value === null || value === void 0 ? void 0 : value.theme) === 'responsive' ? /*#__PURE__*/React.createElement(CollapseArrowRE, null) : /*#__PURE__*/React.createElement(CollapseArrowCE, null);
      })))), this.isOpen() ? /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapsed-content-container",
        className: "collapsed-content-container",
        key: "collapsed-content-container",
        onMouseEnter: this.handleOnMouseEnter,
        onMouseLeave: this.handleOnMouseLeave
      }, this.props.children) : null);
    }
  }]);
}(React.Component);
collapseLabel.displayName = displayNames.COLLAPSE_LABEL;
collapseLabel.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Label text to display */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Callback after toggle */
  onToggle: PropTypes.func,
  /** Callback function to be used in controlled mode */
  customToggle: PropTypes.func,
  /** Disables toggling */
  disabled: PropTypes.bool,
  /** Controlled state of collapse (only with `customToggle`) */
  isOpen: PropTypes.bool,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Title suffix node, usually used for info icon, context menu or similar actions */
  suffix: PropTypes.node,
  /** Title prefix node, usually used for an icon */
  prefix: PropTypes.node,
  /** force suffix to always be visible */
  alwaysShowSuffix: PropTypes.bool,
  /** changing the look of the component  */
  skin: PropTypes.oneOf(['item', 'section']),
  /** Applies bottom divider */
  divider: PropTypes.oneOf(['none', 'enabled'])
};
collapseLabel.defaultProps = {
  disabled: false,
  alwaysShowSuffix: false,
  skin: 'item',
  divider: 'enabled'
};
export default compose(collapseLabel);